<template>
    <div>
        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'日志管理'}]"/>
        <div class="h-content">
            <!--表单-->


            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="模块名称">
							    <el-input clearable v-model="q.moduleName"></el-input>
							</el-form-item>
							<el-form-item label="操作人">
							    <el-input clearable v-model="q.cuname"></el-input>
							</el-form-item>
							<el-form-item label="操作名称">
							    <el-input clearable v-model="q.operationName"></el-input>
							</el-form-item>
							                           
							<el-form-item label="描述">
							    <el-input clearable v-model="q.operationDesc"></el-input>
							</el-form-item>
						</div>
                           
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                           <!--  <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="handleEdit">新建流程
                            </el-button> -->
                        </div>
                    </el-form>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
                    <el-table-column
                            prop="moduleName"
                            label="模块名称"
							:show-overflow-tooltip="true"
                            width="180">
                      <!--   <template slot-scope="scope">
                            <dictname category="progress_type" :v="scope.row.progresstype"/>
                        </template> -->
                    </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="操作人"
								:show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="operationName"
                                label="操作名称"
								:show-overflow-tooltip="true"
                                width="90">
                        </el-table-column>
                        <el-table-column
                                prop="operationDesc"
                                label="描述"
								:show-overflow-tooltip="true"
                                min-width="120">
                        </el-table-column>
                      
                        <el-table-column
                                prop="cucode"
                                label="创建人编码"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                       
                        <el-table-column
                                prop="cdate"
                                label="时间"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                      


                   <!--  <el-table-column
                            fixed="right"
                            label="操作"
                            width="250"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    @click="copeProdef(scope.row)">复制流程</el-button>
                            <el-button
                                    size="mini"
                                    @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button
                                    size="mini"
                                    @click="deleteDef(scope.row)">删除</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    export default {
        components: {},
        data() {
            return {
                //查询属性
                q: {
                    pageSize:20,
                    pageNo:1,
                    total:0,
                    moduleName:"",
                    operationName:"",
                    operationDesc:"",
                    cucode:"",
                    cuname:"",
                    cdate:"",
                },
                //表单
                f:{
                  
                    moduleName:null,
                    operationName:null,
                    operationDesc:null,
                    cucode:null,
                    cuname:null,
                    cdate:null,
                   
                    
                },
                //table列表
                tableData: [],
                //操作标志
                optflag:'save',
            }
        },
        created() {
            this.query();
        },
        methods: {
            query() {
                
                ss.operationService.page(this.q).then(rd=>{
                    this.q.total = rd.total
                    this.tableData = rd.records;
                })
            },
            handleFilter() {
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;

                this.query();
            },
            // deleteDef(obj){
            //     this.$msg.confirm("确认删除？",()=>{
            //         ss.prodefservice.deletebyid(obj.id).then(rd=>{
            //             this.query()
            //         })
            //     })
            // },
           
        
        }
    }
</script>
